import { Context } from "../../../context.js";
import { isLink } from "../../../common/is-link.js";
import { PseudoClassSelector } from "./pseudo-class.js";
/**
 * {@link https://drafts.csswg.org/selectors/#visited-pseudo}
 */
export class Visited extends PseudoClassSelector {
    static of() {
        return new Visited();
    }
    constructor() {
        super("visited");
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element, context = Context.empty()) {
        return isLink(element) && context.hasState(element, Context.State.Visited);
    }
    toJSON() {
        return super.toJSON();
    }
}
(function (Visited) {
    Visited.parse = PseudoClassSelector.parseNonFunctional("visited", Visited.of);
})(Visited || (Visited = {}));
//# sourceMappingURL=visited.js.map